export interface BuyingDefaults {
  productId: string; vendorId: string | null; vendorName: string | null;
  vendorSource: 'contract' | 'preferred' | 'last_po' | null;
  lastRate: number | null; rateSource: 'contract' | 'last_po' | null; lastPoNumber: string | null;
}
interface LineItem { description: string; hsnSac: string; quantity: number; rate: number; gstRate: number; discount: number; productId: string }
const SUPPLIER_WORD = { contract: 'contract supplier', preferred: 'regular supplier', last_po: 'last supplier' } as const;

export function applyBuyingDefaults(item: LineItem, defaults: BuyingDefaults | null, currentVendorId: string): { item: LineItem; vendorId: string; hint: string | null } {
  if (!defaults || (defaults.lastRate === null && !defaults.vendorId)) return { item, vendorId: currentVendorId, hint: null };
  const parts = [
    defaults.lastRate !== null ? `${defaults.rateSource === 'contract' ? 'Contract rate' : 'Last rate'} ₹${defaults.lastRate.toLocaleString('en-IN')}${defaults.lastPoNumber && defaults.rateSource === 'last_po' ? ` (${defaults.lastPoNumber})` : ''}` : null,
    defaults.vendorName && defaults.vendorSource ? `${SUPPLIER_WORD[defaults.vendorSource]} ${defaults.vendorName}` : null,
  ].filter(Boolean);
  return {
    item: defaults.lastRate !== null ? { ...item, rate: defaults.lastRate } : item,
    vendorId: currentVendorId || defaults.vendorId || '',
    hint: parts.join(' · '),
  };
}
